import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import useFetchContentfulData from '../../hooks/useFetchContentfulData';
import { fieldIotProductSelected } from '../../utils/constant';
import SummaryTracker from '../summaryTracker';

const SummaryTrackerSummary = ({ orderData }) => {
  const {
    ratePlan,
    addons,
    additionalServices,
    hardware,
    vehicleInfo
  } = orderData;
  const {
    contentfulValues: { valueGeotab, valueFleetcomplete, valueRaven }
  } = useLocalizedStringsContext();
  const getIotOrderDetilsKey = () => {
    const valueProductSelected = _.get(orderData, fieldIotProductSelected, '');
    let orderDetailsKey;
    switch (valueProductSelected) {
      case valueGeotab:
        orderDetailsKey = 'ioTGeoTabOrderDetails';
        break;
      case valueFleetcomplete:
        orderDetailsKey = 'ioTFleetCompleteOrderDetails';
        break;
      case valueRaven:
        orderDetailsKey = 'ioTRavenOrderDetails';
        break;
      default:
        orderDetailsKey = 'ioTFleetCompleteOrderDetails';
        break;
    }
    return orderDetailsKey;
  };
  const { data: contentfulData } =
    orderData && useFetchContentfulData(getIotOrderDetilsKey());
  return (
    <>
      {orderData && contentfulData && (
        <SummaryTracker
          rateplanList={contentfulData.rateplanList}
          hasAdditonalServices={_.get(
            contentfulData,
            'additionalServicesList',
            ''
          )}
          ratePlans={ratePlan}
          addons={addons}
          additionalServices={additionalServices}
          hardware={hardware}
          vehicleInfo={vehicleInfo}
        />
      )}
    </>
  );
};

SummaryTrackerSummary.propTypes = {
  orderData: PropTypes.shape({
    ratePlan: PropTypes.object,
    addons: PropTypes.object,
    additionalServices: PropTypes.object,
    hardware: PropTypes.object,
    vehicleInfo: PropTypes.arrayOf(PropTypes.object)
  }).isRequired
};

export default SummaryTrackerSummary;
